/**
 * Purple UI candidate: release notice controller (see docs/site-chrome.md).
 *
 * The notice hides itself when dismissed and remembers that per
 * `data-p-dismiss-key` for the browser session (`data-p-dismiss="persistent"`
 * remembers it across sessions). Storage failures only mean the notice shows
 * again. Dispatches `p-release-notice-dismiss` (detail.key) on the notice.
 * Returns a handle like the other Purple UI controllers.
 */
export function initReleaseNotices(root = document) {
  const controller = new AbortController();
  let active = false;
  const storageFor = (notice) => {
    try {
      return notice.dataset.pDismiss === "persistent" ? window.localStorage : window.sessionStorage;
    } catch {
      return null;
    }
  };
  for (const notice of root.querySelectorAll("[data-p-release-notice]")) {
    const key = notice.dataset.pDismissKey ? `p-release-notice:${notice.dataset.pDismissKey}` : "";
    const storage = key ? storageFor(notice) : null;
    try {
      if (storage?.getItem(key) === "dismissed") notice.hidden = true;
    } catch {
      // Unavailable storage: keep the notice visible.
    }
    const button = notice.querySelector("[data-p-release-notice-dismiss]");
    if (!button) continue;
    active = true;
    button.addEventListener("click", () => {
      notice.hidden = true;
      try {
        storage?.setItem(key, "dismissed");
      } catch {
        // Ignore unavailable storage.
      }
      notice.dispatchEvent(new CustomEvent("p-release-notice-dismiss", { bubbles: true, detail: { key: notice.dataset.pDismissKey ?? null } }));
    }, { signal: controller.signal });
  }
  return {
    get active() {
      return active && !controller.signal.aborted;
    },
    destroy() {
      controller.abort();
    },
  };
}
